interface Props {
	onClick?: (e: any) => void;
	style?: React.CSSProperties;
}
export default function Aperture({ style, onClick }: Props) {
	return (
		<div className="overflow-hidden">
			<div
				className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2
				 block dark:hidden w-[723px] h-[719px]
				 bg-[url(https://web-cdn.rockflow.tech/h5/light-popup.png)] bg-no-repeat bg-center bg-contain
				 "
				style={{ ...style }}
				onClick={onClick}
			/>
			<div
				className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 
				hidden dark:block w-[723px] h-[719px]
				 bg-[url(https://web-cdn.rockflow.tech/h5/dark-popup.png)] bg-no-repeat bg-center bg-contain
				"
				style={{ ...style }}
				onClick={onClick}
			/>
		</div>
	);
}
